import { useEffect, useRef, useState } from "react";
import NormalSearch from "../../../components/common/NormalSearch";

type Props = {
  ALL_CITIES: any;
  selectedCityData: any;
  setSelectedCitiesArray?: (data: any) => void;
  coverageType?: string;
  coverageCity?: string;
  coverageCountry?: string;
  error?: string;
  setError?: (data: string) => void;
  isEdit: boolean;
};

const CoverageCities = ({
  setSelectedCitiesArray,
  error,
  setError,
  isEdit,
  coverageType,
  coverageCountry,
  coverageCity,
  selectedCityData = [],
  ALL_CITIES = [],
}: Props) => {
  const [selectedCities, setSelectedCities] =
    useState<string[]>(selectedCityData);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredCities, setFilteredCities] = useState(
    ALL_CITIES?.filter((city: any) =>
      city?.name?.toLowerCase().includes(searchQuery.toLowerCase())
    )
  );
  useEffect(() => {
    setFilteredCities(
      ALL_CITIES?.filter((city: any) =>
        city?.name?.toLowerCase().includes(searchQuery.toLowerCase())
      )
    );
  }, [coverageType, ALL_CITIES, searchQuery]);

  useEffect(()=>{
    setSelectedCities([])
  },[coverageType,coverageCountry, coverageCity])

  useEffect(() => {
    if (setSelectedCitiesArray) {
      setSelectedCitiesArray(selectedCities);
    }
    if (selectedCityData?.length > 0 && setError) {
      setError("");
    }
  }, [selectedCities]);

  useEffect(() => {
    if(selectedCityData?.length > 0){
      setSelectedCities(selectedCityData)
    }
  },[selectedCityData])

  // useEffect(() => {
  //   // setSelectedCities([]);
  //   if (setSelectedCitiesArray && selectedCityData?.length === 0) {
  //     setSelectedCitiesArray([]);
  //   }
  // }, [ALL_CITIES]);

  const toggleCity = (city: string) => {
    setSelectedCities((prev: any) =>
      prev?.includes(city) ? prev.filter((c:any) => c !== city) : [...prev, city]
    );
  };

  const selectAll = () => {
    setSelectedCities([...ALL_CITIES?.map((city: any) => city?.id)]);
  };

  const [visibleCities, setVisibleCities] = useState<any[]>([]);
  const [cityPage, setCityPage] = useState(1);
  const listRef = useRef(null);

  const CITIES_PER_PAGE = 20; // Load 20 cities at a time
  useEffect(() => {
    if (filteredCities?.length) {
      const newCities = filteredCities.slice(0, cityPage * CITIES_PER_PAGE);
      setVisibleCities(newCities);
    }else{
      setVisibleCities([])
    }
  }, [filteredCities, cityPage]);

  const handleScroll = () => {
    const container:any = listRef.current;
    if (!container) return;

    if (
      container.scrollTop + container.clientHeight >=
      container.scrollHeight - 10
    ) {
      // Near bottom, load more
      if (cityPage * CITIES_PER_PAGE < filteredCities.length) {
        setCityPage((prev) => prev + 1);
      }
    }
  };

  return (
    <div>
      {/* <div
        className="py-4 flex justify-between items-center cursor-pointer"
        onClick={() => setIsCollapsed(!isCollapsed)}
      >
        <h2 className="text-base text-[#212121]">Coverage Cities</h2>
        <span>{isCollapsed ? <IconChevronDown /> : <IconChevronUp />}</span>
      </div> */}

      <div className="space-y-4 ">
        {/* Search + Toggle */}
        <div className="flex items-center gap-2 w-full ">
          <NormalSearch
            className="w-full "
            value={searchQuery}
            onChange={(e: any) => setSearchQuery(e.target.value)}
          />
          {/* <button className="w-[14%] bg-[#FBD037] flex justify-center items-center hover:bg-yellow-400 text-[#000000] text-sm font-medium rounded-full py-2">
              <IconArrowsRightLeft />
            </button> */}
        </div>

        {/* Panels */}
        <div className="grid grid-cols-2 gap-4">
          {/* Left: City List */}
          <div className="border border-[#d2d2d2] rounded-lg">
            <div className="flex items-center border-b border-[#d2d2d2] justify-between p-2">
              <h3 className="text-[#1E293B]">
                {coverageType?.[0]?.toUpperCase()}{coverageType?.slice(1)} List{" "}
                {visibleCities?.length - (selectedCities?.length || 0) > 0 &&
                  `(${visibleCities?.length - (selectedCities?.length || 0)})`}
              </h3>
              <button
                onClick={selectAll}
                className="text-[#1E1E1E]/70 text-sm flex items-center space-x-1"
              >
                <input
                  type="checkbox"
                  checked
                  readOnly
                  className="accent-green-500 mr-1"
                />
                <span>Select All</span>
              </button>
            </div>
            <div className="space-y-2 max-h-96 overflow-y-auto p-2">
              <div
                className="max-h-[300px] overflow-auto"
                onScroll={handleScroll}
                ref={listRef}
              >
                {visibleCities.map(
                  (city: any) =>
                    !selectedCities?.includes(city?.id) && (
                      <label
                        key={city?.id}
                        className="flex items-center px-3 py-1 rounded-lg border cursor-pointer text-sm"
                      >
                        <input
                          type="checkbox"
                          checked={selectedCities?.includes(city?.id)}
                          onChange={() => toggleCity(city?.id)}
                          disabled={isEdit}
                          className="mr-2 accent-[#14AE5C]"
                        />
                        {city?.name}
                      </label>
                    )
                )}
              </div>

              {error && (
                <span className="text-red-500 text-sm min-h-[0.5rem] block pl-3">
                  {error || ""}
                </span>
              )}
            </div>
          </div>

          {/* Right: Coverage Cities */}
          <div className="border border-[#d2d2d2] rounded-lg">
            <div className="border-b border-[#d2d2d2]  p-2">
              <h3 className="text-[#1E293B]">Coverage {coverageType?.[0]?.toUpperCase()}{coverageType?.slice(1)} List</h3>
            </div>
            <div className="space-y-2 max-h-96 overflow-y-auto p-2 max-h-[300px]">
              {selectedCities?.map((city) => (
                <div
                  key={city}
                  className="flex items-center px-3 py-1 rounded-lg text-sm"
                >
                  <input
                    type="checkbox"
                    checked
                    onChange={() => toggleCity(city)}
                    readOnly
                    className="mr-2 accent-[#007BFF]"
                  />
                  {ALL_CITIES?.find((e: any) => e?.id === city)?.name}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* {isCollapsed && (
      )} */}
    </div>
  );
};

export default CoverageCities;
